// HowItWorksPage — /how-it-works
// The platform explaining itself: six seats, honest mechanics.
// Every step below maps to shipped, receipted code. Nothing is a roadmap.
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import SEO from '@/components/layout/SEO'
import HowItWorksHub from '@/components/layout/HowItWorksHub'

export default function HowItWorksPage() {
  const { t } = useTranslation()

  return (
    <div style={{ background: '#06060c', minHeight: '100vh', color: '#ffffff', fontFamily: "'Inter', system-ui, sans-serif" }}>
      <SEO
        title="How It Works | Still Waters Academy"
        description="Pick your seat and walk through a real day: parents, students, teachers, principals, sponsors, NGO partners, and church leaders. Every feature described is live today."
        noindex
      />

      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #0A0D17 0%, #141B2E 100%)', borderBottom: '1px solid rgba(255,255,255,0.08)', padding: '64px 24px 40px', textAlign: 'center' }}>
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <p style={{ fontSize: 11, color: '#0ea5e9', fontWeight: 800, letterSpacing: '0.25em', textTransform: 'uppercase', margin: '0 0 14px' }}>
            {t('hiw.page.eyebrow', 'The system, explained by the system')}
          </p>
          <h1 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 'clamp(2.2rem, 5vw, 3.4rem)', fontWeight: 700, margin: '0 0 14px', color: '#ffffff' }}>
            {t('hiw.page.title', 'How everything works')}
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 16, lineHeight: 1.7, margin: '0 auto', maxWidth: 560 }}>
            {t('hiw.page.subtitle', 'Pick your seat and walk through a real day. Every feature below is live today; nothing here is a roadmap.')}
          </p>
          <div style={{ marginTop: 24 }}>
            <Link to="/" style={{ color: '#d4a843', fontWeight: 800, fontSize: 14, textDecoration: 'none' }}>
              ← {t('hiw.page.back', 'Back to the front door')}
            </Link>
          </div>
        </div>
      </div>

      {/* The hub component carries everything */}
      <HowItWorksHub />
    </div>
  )
}